<template lang="pug">
  table(:class="classname")
    thead
      tr(v-if="theadHasChild") 
        th.bl.center.visiable-th(v-for="item in columns", :colspan="item.children.length", :style="{minWidth: item.width + 'px'}") {{item.title}}
          span(v-if="item.key", :data-name="item.key")
            slot(:name="item.key")
          v-tooltip(
            v-if="item.title === '自定义转化指标' && (pagetitle === '搜索推广' || pagetitle === '展示广告')"
            :tip="'360分析不展示建站落地页二维码相关转化数据，如需查看请前往建站线索管理或点睛相关报表'",
            pos="top"
            class="tooltip_icon")
            i.fa.fa-exclamation-circle
      tr(v-if="columnChildren.length != 0")
        th.fixed-width-itemcell(ref="thCell", v-for="column,index in columnChildren", :class="tcellCustomClass(column, index)", :style="{minWidth: column.width + 'px'}")
          slot(:name="column.key + '-th_before'")
          span(v-if="check_all && index == 0" style="margin-right: 30px;")
            v-checkbox(v-model="checkAll" @change.native="checkAllChange()") 
          span(v-else-if="checkbox == true && index == 0" style="margin-left: 46px;")
          | {{column.title}}
          span(:data-name="column.key+'-th'") 
            slot(:name="column.key+'-th'")
          span.sort_icon.margin_icon(v-show="column.sorter")
            i.sort.sort-asc(:class="{'sorted' : checkSorted(column.key, 1)}", @click="orderTable(column, 1)") 
            i.sort.sort-desc(:class="{'sorted' : checkSorted(column.key, 0)}", @click="orderTable(column, 0)") 
            
    //汇总数据
    tbody(v-if="!isLoading && !dataCompared")
      tr(v-if="sumShow")
        td(v-for="item,index in columnChildren", :class="tcellCustomClass(item, index)") 
          span(v-if="checkbox == true && index == 0 && !sumchecked" style="margin-left: 46px;")
          span(v-if="checkbox == true && index == 0 && sumchecked")
            v-checkbox(name="columnItem.key" v-model="sum.checked" @change.native="checkboxChange(sum)", :disabled="item.disabled") 
          span(v-if="index==0 && sumTitleShow(item.key)") 汇总
          div(v-html="item.render(index, sum[item.key], sum)" v-if="item.render && !sumTitleShow(item.key) && !isFixedAndIndicesKey(item.key)", :class="item.key | adctrFilter")
          span(v-if="!item.render && !sumTitleShow(item.key)", :class="item.key | adctrFilter") {{sum[item.key]}}
      tr.sum-children(v-if="sumShow && sum.sdim_list.length > 0",
          v-for="sumItem in sum.sdim_list"
        )
        td(v-for="item,index in columnChildren", :class="tcellCustomClass(item, index)") 
          span(v-if="checkbox == true && index == 0")
            v-checkbox(name="columnItem.key" v-model="sumItem.checked" @change.native="checkboxChange(sumItem)", :disabled="item.disabled") 
          span.compTextIndent(v-if="index==0 && sumTitleShow(item.key)") {{sumItem.sdimname}}
          div(v-html="item.render(index, sumItem[item.key], sum)" v-if="item.render && !sumTitleShow(item.key) && !isFixedAndIndicesKey(item.key)", :class="item.key | adctrFilter")
          span(v-if="!item.render && !sumTitleShow(item.key)", :class="item.key | adctrFilter") {{sumItem[item.key]}}
    tbody(v-if="!isLoading && dataCompared")
      tr(v-if="sumShow")
        td(v-for="item,index in columnChildren", :class="tcellCustomClass(item, index)", :style="{paddingRight: lastTdPR(index), height: '91px'}") 
          span(v-if="checkbox == true && index == 0 && !sumchecked" style="margin-left: 46px;")
          span(v-if="checkbox == true && index == 0 && sumchecked")
            v-checkbox(name="columnItem.key" v-model="sum.sum.checked" @change.native="checkboxChange(sum.sum)", :disabled="item.disabled") 
          span(v-if="index==0 && sumTitleShow(item.key)") 汇总
          span(v-else-if="!sumTitleShow(item.key)", :class="item.key | adctrFilter")
            | {{comparedData(sum.sum[item.key], item.key, sum.sum)}}
          span
            i.fa.margin_icon(v-bind:class="isAsc(sum.sum[item.key])", v-if="!isFixedAndIndicesKey(item.key)")
          p(v-if="!sumTitleShow(item.key) && !specialFixedKey(item.key)")
            | {{reformData(item)}}

    //loading 
    tbody(v-if="isLoading")
      tr
        td.loading(:colspan="columnSpan")
          img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif" v-show="!isFixed")

    //no result
    tbody(v-if="!isLoading && listData.length == 0")
      tr
        td.noresult(:colspan="columnSpan" v-html="emptyShowMsg")

    //data list
    tbody(v-if="!isLoading && listData.length != 0")
      template(v-for="(item,index) in listData")
        tr(@click="toggleChild(index)", :class="{'clickable': hasSdimList(item)}")
          td(v-for="(columnItem,columnIndex) in columnChildren", :class="tcellCustomClass(columnItem, columnIndex)" v-if="!dataCompared")
            span
              slot(:name="columnItem.key + '-td'", :item="item")
            span(v-if="checkbox == true && columnIndex == 0")
              v-checkbox(name="columnItem.key" v-model="item.checked" @change.native="checkboxChange(item)", :disabled="item.disabled") 
            span.relative(v-html="columnItem.render(index, item[columnItem.key], item, columnItem.key)" v-if="columnItem.render", :class="columnItem.key | adctrFilter")
            span.relative(v-else-if="!columnItem.render", :class="columnItem.key | adctrFilter") {{item[columnItem.key]}}
            span.margin_icon(v-show="sumTitleShow(columnItem.key) && hasSdimList(item)")
              i.fa.fa-angle-right(v-show="!item.childshow")
              i.fa.fa-angle-down(v-show="item.childshow") 

          // compare
          td(v-for="columnItem,columnIndex in columnChildren" v-bind:key="columnIndex" v-if="dataCompared", :class="tcellCustomClass(columnItem, columnIndex)", :style="{paddingRight: lastTdPR(index)}")
            span(v-if="checkbox == true && columnIndex == 0")
              v-checkbox(name="columnItem.key" v-model="item.checked" @change.native="checkboxChange(item)") 
            span.relative(:class="columnItem.key | adctrFilter", :title="comparedData(item[columnItem.key],columnItem.key, item)")
              | {{comparedData(item[columnItem.key], columnItem.key, item)}}
            span
              i.fa.margin_icon(v-bind:class="isAsc(item[columnItem.key])", v-if="!specialFixedKey(columnItem.key)")
            span.margin_icon(v-if="sumTitleShow(columnItem.key) && hasSdimList(item)")
              i.fa.fa-angle-right(v-show="!item.childshow")
              i.fa.fa-angle-down(v-show="item.childshow") 

        tr.table-infolist(v-if="item.comp_list && item.comp_list.length != 0")
          td(:colspan="columnSpan")
            table.data-table
              tbody
                tr.table-infolist(v-for="info in item.comp_list")
                  td(v-for="columnItem,columnIndex in columnChildren", :class="tcellCustomClass(columnItem, columnIndex)", :style="{width:tdChildWidthList[columnIndex]}")
                    span(v-html="columnItem.render(columnIndex, info[columnItem.key], info, columnItem.key)" v-if="columnItem.render && !specialFixedKey(columnItem.key)", :class="{'infoTextIndent': sumTitleShow(columnItem.key)}")
                    span( :class="{'infoTextIndent': sumTitleShow(columnItem.key)}" v-else-if="!columnItem.render") {{info[columnItem.key]}}

        tr.table-childlist(v-if="hasSdimList(item)" v-show="item.childshow")
          td(:colspan="columnSpan",
            :class="{'has-scroll-bar': item.sdim_list.length > 10}")
            div.childlist(
              @mousewheel="onMousewheel($event)",
              @scroll="onChildTableScroll",
              :ref="'table_'+index", 
              :data-ref="index", 
              :class="{'has-scroll-bar': item.sdim_list.length > 10}")
              table.data-table
                tbody
                  tr.table-childlist(v-for="child in item.sdim_list")
                    td(v-for="columnItem,columnIndex in columnChildren", :class="tcellCustomClass(columnItem, columnIndex)", :style="{width:tdChildWidthList[columnIndex]}")
                      v-checkbox(name="columnItem.key" v-model="child.checked" @change.native="checkboxChange(child)" v-if="childCheckable(child) && sumTitleShow(columnItem.key) ") 
                      span(v-html="columnItem.render(columnIndex, child[columnItem.key], child)", :class="{'textIndent': !childCheckable(child) && sumTitleShow(columnItem.key), 'compTextIndent': childCheckable(child) && sumTitleShow(columnItem.key)}" v-if="columnItem.render")
                      span(v-else-if="!columnItem.render", :class="{'textIndent': !childCheckable(child) && sumTitleShow(columnItem.key), 'compTextIndent': childCheckable(child) && sumTitleShow(columnItem.key)}") {{child[columnItem.key]}}


</template>

<script>
const noCompKeys = [
  {
    key: 'ttype_d',
    list: {
      0: '--',
      1: '订单',
      2: '注册',
      3: '咨询',
      4: '其他'
    }
  }, {
    key: 'matchtype',
    list:{
      2: '高级精确',
      3: '精确',
      4: '普通短语',
      5: '智能短语',
      6: '广泛'
    }
  }]
export default {
  props: {
    classname: {
      type: String,
      default: 'opt-table'
    },
    columns: {
      type: Array,
      require: true
    },
    sortKey: {
      default: ''
    },
    sortOrder: {
      default: 0
    },
    sum: {
      type: [String, Object],
      default: () => {}
    },
    list: {
      default() {
        return []
      }
    },
    sumchecked: Boolean,
    check_all: {
      default: false
    },
    checkbox: {
      default: false
    },
    checkbox_length: {
      default: 1
    },
    hasScroll: {
      default: false
    },
    isFixed: {
      default: false
    },
    pagetitle: String,
  },
  data() {
    return {
        tdWidthList: [],
        tdChildWidthList: [],
        key: this.sortKey,
        order: this.sortOrder,
        checkAll: false
    }
  },
  watch: {
    sortKey() {
      if(this.key != this.sortKey) {
        this.key = this.sortKey
      }
    },
    sortOrder() {
      if(this.order != this.sortOrder) {
        this.order = this.sortOrder
      }
    },
    columns(newVal, oldVal) {
      if(newVal != oldVal){
        this.columns =  newVal
        this.$nextTick(this.getTdWidthList)
      }
    },
    list() {
      this.$nextTick(this.getTdWidthList)
    }
  },
  computed: {
    emptyShowMsg() {
      return this.isFixed ? '&nbsp;' : '无相关数据'
    },
    theadHasChild() {
      return _.has(this.columns[0], 'children')
    },
    sumShow() {
      return !_.isEmpty(this.sum)
    },
    dataCompared: function(){
      if (this.sumShow) {
        return  _.has(this.sum, 'comparedSum') && this.sum.comparedSum && this.sum.defaultSum ? true : false
      } else {
        return this.listData.length > 0 
          && _.has(this.listData[0], 'comp_list')
          && this.listData[0].comp_list.length > 0
      }
    },
    columnSpan() {
      return this.columnChildren.length
    },
    // 获取state中loading的状态
    isLoading() {
      return this.$store.state.tableLoading
    },
    listData() {
      let listData = _.concat([], this.list)
      _.map(listData, (item, index) => {
        if(_.has(item, "sdim_list") && item.sdim_list){
          this.$set(item, 'childshow', true)
        }
        return item
      })
      return listData
    },
    columnChildren() {
      //如果columns中单项有children
      if(this.theadHasChild){
        let children = _.reduce(this.columns, (result, item) => {
          if(_.has( item.children[0], 'class')){
            item.children[0].class += " bl"
          }else{
            item.children[0].class="bl"
          }
          return _.concat(result, item.children)
        }, [])
        return children
      }else {
        const className = _.has(this.columns[0], 'class') ? `${this.columns[0].class} bl`: 'bl'
        this.$set(this.columns[0], 'class', className )
        return this.columns
      }
    }
  },
  mounted() {
    this.$nextTick(this.getTdWidthList);

    window.addEventListener('resize', this.getTdWidthList, false);
  },
  methods: {
    reformData (item, index) {
      const currentData = item.render(index, this.sum.defaultSum[item.key], this.sum.defaultSum)
      const compData = item.render(index, this.sum.comparedSum[item.key], this.sum.comparedSum)
      return currentData !== '' && compData !== '' ? `${currentData}(${compData})` : ''
    },
    lastTdPR(index) {
      return '20px'
    },
    onMousewheel(e) {
      let dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0
      let scrollTop = e.currentTarget.scrollTop

      if ((dir === 'up' && scrollTop <= 0) ||
        (dir === 'down' && e.currentTarget.offsetHeight + scrollTop === e.currentTarget.scrollHeight)
      ){
        return e.preventDefault();
      }
    },
    onChildTableScroll(e) {
      this.$emit('childTableScroll', {
        e,
        fixed: this.isFixed,
        ref: e.target.getAttribute('data-ref')
      })
    },
    //数组中的key对应td显示文案----汇总
    sumTitleShow(key) {
      const titleKeys = ['name', 'date', 'datum', 'query', 'landpage', 'multiname', 'groupName', 'advert', 'trans']
      return titleKeys.indexOf(key) > -1
    },
    specialFixedKey(key) {
      const titleKeys = ['keyword', 'matchtype', 'bid_status', 'plan', 'groupName', 'ttype_d']
      return titleKeys.indexOf(key) > -1
    },
    isFixedAndIndicesKey(key) {
      const titleKeys = ['bid_status']
      return titleKeys.indexOf(key) > -1
    },
    checkAllChange() {
      let checklist = []
      this.listData.map(item => {
        item.checked = this.checkAll
        return item
      })
      checklist = this.checkAll ? this.listData : []
      this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
    },
    hasSdimList(item) {
      return item && item.sdim_list != undefined && item.sdim_list.length > 0 ? true : false
    },
    //获取th的width
    getTdWidthList() {
      let thCellList = this.$refs.thCell
      let tdWidthList = []
      let tdChildWidthList = []
      let length = _.isEmpty(thCellList) ? 0 : thCellList.length
      _.map(thCellList, (item, index) => {
        
        const firstMg = 20    //首个元素间隔20px
        const lastMg = 0      //内部table与外部容器td相差7px
        //isFixed和hasScroll同状态首元素才有20px的间隔，其他没有,相减保证内外容器等宽才能保证单元格等宽
        let space = index == 0 ? (this.isFixed == this.hasScroll ? firstMg : 0) : (index == length -1 ? lastMg : 0)
        let childTdWidth = item.offsetWidth - space
        let tdWidth = item.offsetWidth
        tdChildWidthList.push(childTdWidth + 'px')
        tdWidthList.push(tdWidth + 'px')
      })
      this.tdWidthList = tdWidthList
      this.tdChildWidthList = tdChildWidthList
    },
    isAsc(value) {
      if (typeof value === 'number') {
          return value == 0 ? '' : value > 0 ? 'fa-long-arrow-up red':'fa-long-arrow-down green'
      } else {
          return '';
      }
    },
    // 单元格css
    tcellCustomClass(item,index) {
      return _.has(item, 'class') ? _.has(item, 'sorter') ? index && index == this.columnChildren.length - 1 ? item.class + ' last-sort-pr' : item.class + ' sort_pr' : item.class  : ''

    },
    // 是否是当前排序的key
    checkSorted(key, order) {
      return this.key == key && this.order == order
    },
    // 排序方法调用
    orderTable(item, order) {
      this.key = item.key
      this.order = order
      item.sorter(item.key, order)
    },
    childCheckable(item) {
      return this.checkbox && _.has(item, 'checked')
    },
    checkboxChange(item) {
      let checklist = _.concat([], this.$store.state.tableCheckList)
      if(item.checked){
        checklist.push(item)
        //全选判断
        if(this.check_all && checklist.length == this.checkbox_length){
          this.checkAll = true
        }
        if(checklist.length > parseInt(this.checkbox_length)){
          this.$set(checklist[0], 'checked', false)
          checklist.splice(0,1)
        }
      }else{
        this.checkAll = false
        checklist = _.filter(checklist, (item) => item.checked)
      }
      this.$store.dispatch("SET_DRAWCHART", true)
      this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
    },
    toggleChild(index) {
      if( _.has(this.listData[index], 'sdim_list') && this.listData[index].sdim_list.length == 0 ) return
      let newItem = this.listData[index]
      _.has(this.listData[index], 'childshow') && this.$set(this.listData[index], 'childshow', !newItem.childshow)
    },
    comparedData(value, key, item) {
      if (typeof value === 'number'){
        if(_.find(noCompKeys, {key: key})) {
          const remark = key === 'ttype_d' && +value === 4 ? ' - ' + item.remark : ''
          return  _.find(noCompKeys, {key: key}).list[value] + remark
        }
        return Math.abs(value) + '%'
      }else{
        return _.isNull(value) ? '-' : value
      }
    }
  },
  filters: {
    // Adblock Plus 会过滤到 .adctr 元素
    adctrFilter(value) {
      if (/adctr/.test(value)) return 'adv_ctr';
      return value;
    }
  },
  destroyed () {
      window.removeEventListener('resize', this.getTdWidthList);
  }
}

</script>
<style scoped>
  .compTextIndent {
    margin-left: 20px;
  }
  .table-infolist .bl .infoTextIndent {
    margin-left: 46px;
  }
  .textIndent {
    margin-left: 66px;
  }
  .fixed-width-cell {
    min-width: 300px;
  }
  .fixed-width-itemcell {
    min-width: 100px;
  }
  /********正常表格显示含有icon********/
  .opt-table td:last-child {
    padding-right: 28px;
  }
  /************左侧固定列无右侧padding*****************/
  .fixed-table .table-childlist th:last-child, 
  .fixed-table .table-childlist td:last-child {
    padding-right: 0px;
  }
  .fa--empty {
    width: 13px;
    height: 5px;
    display: inline-block;
  }
  .visiable-th {
    overflow: visible;
  }
  .bluethead td.has-scroll-bar,
  .scroll-box td.has-scroll-bar {
    padding-right: 13px!important;
  }
  .has-scroll-bar table td:last-child{
    padding-right: 29px;
  }
  .relative {
    position: relative;
  }
  .sum-children td{
    background: #F7F7FA;
  }
  .opt-table.bluethead {
    thead tr {
      background: #596980;
      th {
        color: #fff;
      }
      .sort {
        color: #999;
      }
      .sorted {
        color: #fff;
      }
    }
  }
  .tooltip_icon{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// base-table.vue?47fb8385